import React from "react";
import ContactMap from "../components/Contact/ContactMap";
import ContactForm from "../components/Contact/ContactForm";
import { Banner } from "../components/common/Banner";
import FeedbackForm from "../components/Contact/FeedbackForm";


const Contact: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    return (
        <>
            <Banner banner_title={banner_title} />
            <ContactMap />
            <ContactForm />

        </>
    )
}
export default Contact;